/* ============================================================
   NORTHSHEEP — Collection grid-density toggle
   Switches the product grid between the section's columns ("standard") and a
   larger view ("large" = 1 col mobile / 2 col desktop) by toggling a single
   class on #product-grid. The cards themselves are untouched. The choice is
   saved per device and re-applied after Dawn re-renders (sort/filter/paginate).
   ============================================================ */
(function () {
  'use strict';
  if (window.__nsGridToggleLoaded) return;
  window.__nsGridToggleLoaded = true;

  var KEY = 'northsheep_grid_density';
  function get() { try { return localStorage.getItem(KEY) === 'large' ? 'large' : 'standard'; } catch (e) { return 'standard'; } }
  function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function grid() { return document.getElementById('product-grid') || document.querySelector('[data-ns-fav-page-grid]'); }

  /* IMAGE SIZES FOLLOW THE COLUMNS.

     The card's `sizes` is written for the standard grid (two columns on a
     phone), so in the one-column large view the browser picked a srcset
     candidate half the width it now fills and the photo went soft. In the
     large view each card image gets sizes for one fewer column (matching
     ns-grid-toggle.css); the original value is kept in a data attribute and
     put back for the standard view. Swatch thumbnails keep their own. */
  var LARGE_SIZES = '(min-width: 1400px) 415px, (min-width: 990px) calc((100vw - 156px) / 3), (min-width: 750px) calc((100vw - 122px) / 2), calc(100vw - 30px)';

  function applySizes(d) {
    var g = grid();
    if (!g) return;
    var imgs = g.querySelectorAll('.card__media img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('.ns-card-swatch, .ns-card-swatches')) continue;
      if (d === 'large') {
        if (!img.hasAttribute('data-ns-sizes-orig')) img.setAttribute('data-ns-sizes-orig', img.getAttribute('sizes') || '');
        if (img.getAttribute('sizes') !== LARGE_SIZES) img.setAttribute('sizes', LARGE_SIZES);
      } else if (img.hasAttribute('data-ns-sizes-orig')) {
        var orig = img.getAttribute('data-ns-sizes-orig');
        if (orig) img.setAttribute('sizes', orig);
        else img.removeAttribute('sizes');
        img.removeAttribute('data-ns-sizes-orig');
      }
    }
  }

  function apply(d) {
    var g = grid();
    if (g) g.classList.toggle('ns-grid--large', d === 'large');
    applySizes(d);
    document.querySelectorAll('[data-ns-grid-toggle] [data-ns-grid]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ns-grid') === d ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ns-grid]') : null;
    if (!btn) return;
    e.preventDefault();
    var d = btn.getAttribute('data-ns-grid') === 'large' ? 'large' : 'standard';
    set(d);
    apply(d);
  });

  function init() { apply(get()); watch(); }

  /* Cards that arrive later — a lazy batch, a client-side filter render, the
     favourites page re-rendering its grid — carry the standard sizes. Only the
     large view has anything to change, and it is debounced to the house 60ms:
     a curate drag re-inserts cards every frame. */
  var sizesT = null;
  function scheduleSizes() {
    if (get() !== 'large') return;
    clearTimeout(sizesT);
    sizesT = setTimeout(function () { applySizes(get()); }, 60);
  }
  document.addEventListener('ns:cards-appended', scheduleSizes);

  // Dawn replaces #ProductGridContainer (and the count + toggle) on sort/filter/
  // pagination — re-apply the saved density to the fresh grid + toggle.
  var mo = null;
  var watched = null;
  if (window.MutationObserver) {
    var t = null;
    mo = new MutationObserver(function (muts) {
      var cards = false;
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var nd = nodes[j];
          if (nd.nodeType !== 1) continue;
          if (nd.id === 'product-grid' || nd.id === 'ProductGridContainer' ||
              (nd.querySelector && (nd.querySelector('#product-grid') || nd.querySelector('[data-ns-grid-toggle]'))) ||
              (nd.matches && nd.matches('[data-ns-grid-toggle]'))) {
            clearTimeout(t); t = setTimeout(init, 0); return;
          }
          if (!cards && (nd.tagName === 'IMG' || (nd.querySelector && nd.querySelector('img')))) cards = true;
        }
      }
      if (cards) scheduleSizes();
    });
  }

  /* Watch the grid's own section, not the whole document. Dawn's facets only
     ever replace what is INSIDE that section (the grid container's innerHTML,
     the product count holding the toggle), so the section element itself
     survives every sort and filter, and header, drawer and footer mutations
     no longer wake this up. The theme editor replaces the section element, so
     shopify:section:load runs init() and this re-points. No section found:
     the old document-wide watch. */
  function watch() {
    if (!mo) return;
    var g = grid();
    var host = (g && g.closest('.shopify-section')) || document.documentElement;
    if (host === watched) return;
    mo.disconnect();
    watched = host;
    try { mo.observe(host, { childList: true, subtree: true }); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
